const scrollSections = document.querySelectorAll('.scroll-check'),
    scrollNavLinks = document.querySelectorAll('.page-scroll__link');

function scrollSection(links) {
    [ ...links ].forEach(link => {
        link.addEventListener('click', function H(currentLink) {
            let hash = this.hash.replace('#', '');

            if(scrollSections.length !== 0) {
                [ ...scrollSections ].forEach(function H(scrollSection) {
                    if(hash === scrollSection.dataset.scroll) {
                        currentLink.preventDefault();
                        currentLink.stopPropagation();

                        let headHeight;
                        if(window.innerWidth <= 1100) {
                            headHeight = 59;
                        } else {
                            headHeight = 74;
                        }

                        $('html, body').animate({ scrollTop: $(`[data-scroll="${hash}"]`).offset().top - headHeight }, 1500);

                        setTimeout(() => { location.hash = `#${hash}`; }, 301);
                    }
                });
            }
        });
    });
}
scrollSection(scrollNavLinks);

window.addEventListener('load', () => {
    let hash = location.hash.replace('#', '');

    if(hash !== '') {
        let headHeight;
        if(window.innerWidth <= 1100) {
            headHeight = 59;
        } else {
            headHeight = 74;
        }

        $('html, body').animate({ scrollTop: $(`[data-scroll="${hash}"]`).offset().top - headHeight }, 1500, () => {
            const x = window.scrollX,
                y = window.scrollY;

            setTimeout(() => { window.scrollTo(x, y); }, 301);
        });
    }
});
